var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtraJobIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4213 7.40944C14.7467 7.73488 14.7467 8.26252 14.4213 8.58795L8.58795 14.4213C8.26252 14.7467 7.73488 14.7467 7.40944 14.4213L1.57611 8.58795C1.41336 8.42521 1.33201 8.2119 1.33203 7.9986V3.83203C1.33203 2.45132 2.45132 1.33203 3.83203 1.33203H7.99893C8.21212 1.33209 8.42529 1.41345 8.58795 1.57611L14.4213 7.40944ZM3.83203 4.66536C4.29227 4.66536 4.66536 4.29227 4.66536 3.83203C4.66536 3.37179 4.29227 2.9987 3.83203 2.9987C3.37179 2.9987 2.9987 3.37179 2.9987 3.83203C2.9987 4.29227 3.37179 4.66536 3.83203 4.66536Z",
    fill: "#3A836C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraJobIcon);
export default __webpack_public_path__ + "static/media/extra-job-icon.7f491724e9fc55330ea4cd3ee9c6cff6.svg";
export { ForwardRef as ReactComponent };